import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'
import Cookies from 'js-cookie'

Vue.use(Router)

let router = new Router({
    routes: [
        {
            path: '/',
            name: 'index',
            redirect: '/app/home_v3'
        },
        {
            path: '/app',
            name: 'base',
            component: resolve => require(['@/components/Common/Base'], resolve),
            children: [
                {
                    path: 'home',
                    name: 'home',
                    components: {
                        default: resolve => require(['@/components/DashBroad/Dashbroad'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'home_v2',
                    name: 'home_v2',
                    components: {
                        default: resolve => require(['@/components/DashBroad/DashbroadV2'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'home_v3',
                    name: 'home_v3',
                    components: {
                        default: resolve => require(['@/components/DashBroad/DashbroadV3'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'sale/index',
                    name: 'sale_index',
                    components: {
                        default: resolve => require(['@/components/Sale/SaleIndex'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'sale/index_v2',
                    name: 'sale_index_v2',
                    components: {
                        default: resolve => require(['@/components/Sale/SaleIndexV2'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'sale/category',
                    name: 'sale_category',
                    components: {
                        default: resolve => require(['@/components/Sale/SaleCategory'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'sale/category_v2',
                    name: 'sale_category_v2',
                    components: {
                        default: resolve => require(['@/components/Sale/SaleCategoryV2'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'sale/rank',
                    name: 'sale_rank',
                    components: {
                        default: resolve => require(['@/components/Sale/SaleRank'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'sale/rank_v2',
                    name: 'sale_rank_v2',
                    components: {
                        default: resolve => require(['@/components/Sale/SaleRankV2'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'sale/rank_v3',
                    name: 'sale_rank_v3',
                    components: {
                        default: resolve => require(['@/components/Sale/SaleRankV3'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'sale/staff_rank_v2',
                    name: 'sale_staff_rank_v2',
                    components: {
                        default: resolve => require(['@/components/Sale/SaleStaffRankV2'], resolve),
                        search: resolve => require(['@/components/Common/SimpleSearch'], resolve)
                    }
                },
                {
                    path: 'sale/price',
                    name: 'sale_price',
                    components: {
                        default: resolve => require(['@/components/Sale/SalePrice'], resolve),
                        search: resolve => require(['@/components/Common/ProductSearch'], resolve)
                    }
                },
                {
                    path: 'sale/order',
                    name: 'sale_order',
                    components: {
                        default: resolve => require(['@/components/Sale/SaleOrderList'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'sale/order_v2',
                    name: 'sale_order_v2',
                    components: {
                        default: resolve => require(['@/components/Sale/SaleOrderListV2'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'sale/order/:sap_no',
                    name: 'sale_detail',
                    components: {
                        default: resolve => require(['@/components/Sale/SaleOrderDetail'], resolve)
                    },
                    props: {default: true}
                },
                {
                    path: 'sale/order_v2/:sap_no',
                    name: 'sale_detail_v2',
                    components: {
                        default: resolve => require(['@/components/Sale/SaleOrderDetailV2'], resolve)
                    },
                    props: {default: true}
                },
                {
                    path: 'stock/tyre',
                    name: 'stock_tyre',
                    components: {
                        default: resolve => require(['@/components/Stock/StockTyre'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'stock/other',
                    name: 'stock_other',
                    components: {
                        default: resolve => require(['@/components/Stock/StockOther'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'stock/total',
                    name: 'stock_total',
                    components: {
                        default: resolve => require(['@/components/Stock/StockTotal'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'stock/age',
                    name: 'stock_age',
                    components: {
                        default: resolve => require(['@/components/Stock/StockAge'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'member/index',
                    name: 'member_index',
                    components: {
                        default: resolve => require(['@/components/Member/MemberIndex'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'member/stat',
                    name: 'member_stat',
                    components: {
                        default: resolve => require(['@/components/Member/MemberStat'], resolve),
                        search: resolve => require(['@/components/Common/SimpleSearch'], resolve)
                    }
                },
                {
                    path: 'member/oil',
                    name: 'member_oil',
                    components: {
                        default: resolve => require(['@/components/Member/MemberOilList'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'member/car',
                    name: 'member_car',
                    components: {
                        default: resolve => require(['@/components/Member/MemberCarList'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'member/snapshot',
                    name: 'member_snapshot',
                    components: {
                        default: resolve => require(['@/components/Member/MemberSnapshot'], resolve),
                        search: resolve => require(['@/components/Common/Search'], resolve)
                    }
                },
                {
                    path: 'product',
                    component: resolve => require(['@/components/Base/ProductList'], resolve)
                },
                {
                    path: '/version',
                    name: 'version',
                    component: resolve => require(['@/components/Common/VersionDescription'], resolve)
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: resolve => require(['@/components/Common/Login'], resolve)
        },
        {
            path: '/author',
            name: 'author',
            component: resolve => require(['@/components/Common/Author'], resolve)
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (!store.state.userInfo.token && to.path !== '/author' && to.path !== '/login') {
        // 第一次进入项目
        // 路由钩子：无Token 非验证页和登录页面执行
        Cookies.set('dssLoginUrl', to.fullPath) // 保存用户进入的url
        next('/author')
        return false
    }
    next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js